import React, { FunctionComponent, useCallback } from 'react'
import { useDropzone, FileRejection, DropEvent } from 'react-dropzone'
import IMTheme from '../../../style/IMTheme'
import { Text } from '@wework/dieter-ui'
import { ImgIcon } from '../../Icons'
import css from './DragNDropFile.module.scss'
import classnames from 'classnames'

interface DragNDroopFileProps {
  onDrop: <T extends File>(
    acceptedFiles: T[],
    fileRejections: FileRejection[],
    event: DropEvent
  ) => void
  accept: string
  multiple: boolean
}

const DragNDroopFile: FunctionComponent<DragNDroopFileProps> = ({
  onDrop,
  accept,
  multiple = false,
}) => {
  const handleDrop = useCallback(
    (acceptedFiles, fileRejections, event) => {
      onDrop(acceptedFiles, fileRejections, event)
    },
    [onDrop]
  )
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
  } = useDropzone({ onDrop: handleDrop, accept: accept, multiple: multiple })
  const textStyle = {
    fontSize: IMTheme.fontSizes[1],
    color: IMTheme.colors.darkGray,
    textAlign: 'center',
  }
  return (
    <div
      {...getRootProps()}
      className={classnames(
        css.dropzone,
        isDragActive && css.active
        // isDragAccept && css.accepted,
        // isDragReject && css.rejected
      )}
    >
      <input className="dropzone-input" {...getInputProps()} />
      <ImgIcon />
      {acceptedFiles.length === 0 ? (
        <Text style={textStyle}>
          {'Drag & drop or '}
          <span className={css.higlihtedText}>select</span>
          {' an image.'}
        </Text>
      ) : (
        <Text style={textStyle}>
          {`Loaded ${acceptedFiles[0]?.name || '__'}`}
        </Text>
      )}
    </div>
  )
}

export default DragNDroopFile
